import * as Yup from 'yup'
import { TranslationDictionary } from '@plandi/common'

export const sendMessageSchema = (
  translate: TranslationDictionary['data'] | undefined,
  locale: string
) =>
  Yup.object().shape({
    name: Yup.string()
      .min(2, translate?.['min-field-length']?.replace('%d', '2'))
      .max(200, translate?.['max-field-length']?.replace('%d', '200'))
      .required(translate?.['required-field']),
    phone: Yup.string().matches(
      /[0-9]+$/,
      translate?.['phone-number-contain-10-digits'] ??
        'Номер телефона должен содержать код и 10 цифр'
    ),
    email: Yup.string().email(
      locale === 'ru' ? 'Неправильный email' : 'Wrong email'
    ),
    message: Yup.string()
      .min(2, translate?.['min-field-length']?.replace('%d', '2'))
      .max(200, translate?.['max-field-length']?.replace('%d', '200'))
      .required(translate?.['required-field'])
  })
